module.exports = __webpack_public_path__ + "static/media/landing_roundtrip.9888c3d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/landing_roundtrip.svg
// module id = 236
// module chunks = 27